import { theme } from './theme';
export const buttonDark = {
    backgroundColor: theme.palette.common.darkGrey2,
    color: theme.palette.common.lightGrey6,
    width: 'fit-content',
    minWidth: 'fit-content',
    fontWeight: 600,
    borderRadius: '40px',
    border: '3px transparent solid',
    '&:hover': {
        backgroundColor: theme.palette.common.darkBlue2
    },
    '&[disabled]': {
        color: theme.palette.common.darkGrey8,
        backgroundColor: theme.palette.common.lightGrey9,
        borderColor: 'transparent'
    },
    '&:focus': {
        border: '3px solid  #4FA8FF'
    }
};
export const buttonPrimary = {
    backgroundColor: theme.palette.common.darkPink,
    color: theme.palette.common.white,
    fontWeight: 600,
    borderRadius: '40px',
    border: '3px transparent solid',
    '&:hover': {
        backgroundColor: theme.palette.common.brandPrimary60
    },
    '&:focus': {
        outline: `3px ${theme.palette.common.brandPrimary60} solid`,
        outlineOffset: '5px'
    },
    '&:active': {
        backgroundColor: theme.palette.common.brandPrimary70
    },
    '&.Mui-disabled, &[disabled]': {
        backgroundColor: theme.palette.common.monochrome15,
        color: theme.palette.common.monochrome50
    }
};
export const buttonOutlineDark = {
    backgroundColor: theme.palette.common.white,
    border: `2px solid ${theme.palette.common.lightGrey14}`,
    color: theme.palette.common.primaryDark,
    '&:hover': {
        color: theme.palette.common.lightGrey6,
        backgroundColor: theme.palette.common.primaryDark,
        border: `2px solid ${theme.palette.common.primaryDark}`
    },
    '&[disabled]': {
        color: theme.palette.common.darkGrey8,
        border: `2px solid ${theme.palette.common.lightGrey9}`,
        backgroundColor: theme.palette.common.white
    },
    '&:focus': {
        border: '2px solid  #4FA8FF'
    }
};
//# sourceMappingURL=button.js.map